module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-6@3x.ver2_0_2.jpg?ddc4ac93";